'use strict';
import {Injectable,Inject} from 'ng-metadata/core';
import {getCitationConfiguration, getVid, getBackendSystem, getInstitutionCode} from '../appConfig/appConfigForward';
import { JwtUtilService } from '../security/jwtUtil.service';
import {StorageUtil} from "../infra/storageUtil.service";
import {STATE_NAMES} from "../primoExplore/primoExploreStates.module";
import {ConfigurationUtil} from "./configurationUtil.service";

const get = require('lodash/get');
const md5 = require('md5');

@Injectable()
export class AnalyticsUtils {
	public eventsNames = {
		NAVIGATE_MAIN_MENU: 'Main Menu Links',
		SIGN_IN: 'Sign In',
		SIGN_OUT: 'Sign Out',
		DISPLAY_FULL_RECORD: 'Display Full Record',
		ONLINE_RESOURCE_LINK: 'Online Resource Link',
		ADDITIONAL_LINKS: 'Additional Links',
		SORT: 'Sort',
		CREATE_PHYSICAL_REQUEST: 'Create Physical Request',
		EXPAND_RESULTS: 'Expand Results',
		FRBR_LINK: 'FRBR Link',
		USER_MENU_LINKS: 'User Menu Links',
		LATERAL_LINKS: 'Lateral Links',
		CHANGE_LANGUAGE: 'Change Language',
		PAGINATION: 'Pagination',
		FACETS_USAGE: 'Facets Usage',
		SEARCH: 'Search'
	}

	private pageNames = {
		'search' 				: 'Search Page',
		'jsearch'				: 'journal Search',
		'npsearch'				: 'Newspaper Search',
		'jfulldisplay'			: 'Journal Full Display',
		'npfulldisplay'			: 'Newspaper Full Display',
		'dbsearch'				: 'Database Search',
		'dbfulldisplay'			: 'Database Full Display',
		'researcherAssistant'	: '???',
		'researchAssistant'	    : 'CDI Research Assistance',
		'collectionDiscovery'	: 'Collection Discovery',
		'openurl'				: 'Services Page (openurl)',
		'viewitopenurl'			: 'View Online Openurl',
		'fulldisplay'			: 'Full Display',
		'legantogetit'			: 'Leganto Get It',
		'favorites'				: 'Favorites Page',
		'tags'					: 'Tags Page',
		'person'				: 'Person Page',
		'account'				: 'My Library Card',
		'blankIll'				: 'Blank ILL request',
		'purchaseRequest'		: 'Blank Purchase Request',
		'deposit'				: 'Deposit',
		'delivery'				: 'Controlled Digital Lending',
		'login'					: 'Log In',
		'citationTrails'		: 'Citation Trail',
		'sourceRecord'			: 'Source Record',
		'citationlinker'		: 'Citation Linker',
		'chapters'				: 'Chapters Page',
		'model'					: '???',
		'browse'				: 'Browse Page',
		'orgList'				: 'Browse Research Units',
		'authsearch'			: 'Authority Search'

		//, home page ,main menu, Resource Sharing (ILL),,,Fetch item (Citation Linker)

	}

	private ANALYTICS_API_URL: string;

    constructor(@Inject('$http') private $http: ng.IHttpService,
				@Inject('$translate') private $translate: ng.translate.ITranslateService,
				@Inject('restBaseURLs') restBaseURLs,
				@Inject('$state') private $state:angular.ui.IStateService,
				private storageUtil: StorageUtil,
				private configurationUtil: ConfigurationUtil,
				private jwtUtilService: JwtUtilService) {
		this.ANALYTICS_API_URL = restBaseURLs.analyticsURL+'?vid='+getVid();

	}

	public trackUsage(event, payload) {
		if (!this.isMixpanelEnabled()) {
			return;
		}

		if (!event) {
			console.log('No event name found');
			return;
		}

		if (!payload) {
			console.log('Payload is empty');
		}

		payload.event = event;
		this.addGeneralClientDetails(payload);
		this.addGeneralPrimoProperties(payload);
		this.$http.post(this.ANALYTICS_API_URL,payload).then((response) => {},
			(response) => {
			console.log('error');
		});
	}

	public storeDeviceId(jwt) {
		let obj = jwt ? this.jwtUtilService.decodeJWT(jwt) : this.jwtUtilService.getDecodedToken();
		if (!obj.signedIn && obj.userGroup === 'GUEST') {
			this.storageUtil.sessionStorage.setItem("mixPanelDeviceId", md5(jwt));
		}
	}

	private isMixpanelEnabled() {
		return (this.ANALYTICS_API_URL && this.configurationUtil.isMixpanelEnabled());
	}

	private addGeneralClientDetails(payload) {
		if (!payload) {
			return
		}

		//general primo_properties
		payload.$screen_height = window.screen.availHeight;
		payload.$screen_width = window.screen.availWidth;
	}

	private getDeviceID() {
		return this.storageUtil.sessionStorage.getItem('mixPanelDeviceId'); //primoExploreJwt
	}

	private getUserID() {
		let jwt = this.storageUtil.sessionStorage.getItem('primoExploreJwt');
		let obj = jwt ? this.jwtUtilService.decodeJWT(jwt) : this.jwtUtilService.getDecodedToken();
		if (!obj.signedIn && obj.userGroup === 'GUEST') {
			return;
		}
		return md5(obj.userName);
	}

	private getUserType() {
		let jwt = this.storageUtil.sessionStorage.getItem('primoExploreJwt');
		let obj = jwt ? this.jwtUtilService.decodeJWT(jwt) : this.jwtUtilService.getDecodedToken();
		if (obj.signedIn || obj.userGroup !== 'GUEST') {
			return 'Logged In';
		}
		return 'Guest';
	}

	private addGeneralPrimoProperties(payload) {
		//Session Identifier
		payload.$device_id = this.getDeviceID();
		let userId = this.getUserID();
		if (userId) {
			payload.$user_id = userId;
		}

		payload['User Type'] = this.getUserType();

		let decodedToken = this.jwtUtilService ? this.jwtUtilService.getDecodedToken() : undefined;
		if (!decodedToken) {
			userGroup = 'Guest';
		}
		let userGroup = get(decodedToken, 'userGroup');
		if (!userGroup) {
			userGroup = 'Guest';
		}
		userGroup = userGroup.toLowerCase();
		userGroup = userGroup.charAt(0).toUpperCase() + userGroup.slice(1);
		payload['User Group'] = userGroup; 				// User Group

		payload['Primo View'] = getVid(); 				// Primo View

		let inst_code = getInstitutionCode();
		let inst_name = this.$translate.instant(inst_code);
		payload['Institution Code'] = inst_code; 			// Institution Code
		payload['Institution Name'] = inst_name; 			// Institution Name

		let campusStatus = 'No';
		if (this.jwtUtilService.getDecodedToken().onCampus == 'true') {
			campusStatus = 'Yes';
		}
		payload['On Campus'] = campusStatus; 		// On Campus

		//AVG Response Time


		payload['Page Name'] = this.getPageName();
		// Page Name

		payload['$referrer'] = document.referrer;
		payload['$referring_domain'] = document.referrer.split('/')[2];	}

	private getPageName() {
		let currentUrl = window.location.toString();
		let page = currentUrl.substring(currentUrl.lastIndexOf('\/') + 1, currentUrl.lastIndexOf('\?')); //get the page name, 'search', 'fullview', etc...
		return this.pageNames[page];
	}
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/analyticsUtils.service.ts